export default __webpack_public_path__ + "static/media/error.181691c0.png";